import React from 'react';
import { Button, FlatList, ScrollView, Modal } from 'native-base';
import { MenuSortKey, SortByProp, SortDirection, useDutchieStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { useShopStyles } from '~/shared/styles';

export type SortByModalProp = {
    showSortBy: boolean;
    setShowSortBy: (boolean) => void;
};

export const SortByModal = ({ showSortBy, setShowSortBy }: SortByModalProp) => {

    const { setSortByProp } = useDutchieStore();
    const { pressable_text, section_background } = useShopStyles();
    const sortOptions : SortByProp[] = [
        { menuSort: { key: MenuSortKey.Potency, direction: SortDirection.Desc }, label: 'potency: high to low' },
        { menuSort: { key: MenuSortKey.Potency, direction: SortDirection.Asc }, label: 'potency: low to high' },
        { menuSort: { key: MenuSortKey.Popular, direction: SortDirection.Desc }, label: 'popular first' },
        { menuSort: { key: MenuSortKey.Price, direction: SortDirection.Desc }, label: 'price: high to low' },
        { menuSort: { key: MenuSortKey.Price, direction: SortDirection.Asc }, label: 'price: low to high' },
    ];

    return (
        <Modal isOpen={showSortBy}>
            <Modal.Content>
                <Modal.Header>sort by</Modal.Header>
                <Modal.CloseButton
                    bg={section_background}
                    _icon={{
                        color: pressable_text,
                    }}
                    onPress={() => setShowSortBy(false)}
                />
                <Modal.Body>
                    <ScrollView pb={4}>
                        <FlatList
                            data={sortOptions}
                            renderItem={({ item }: { item: SortByProp }) =>

                                <Button
                                    onPress={() => {

                                        setSortByProp(item);
                                        setShowSortBy(false);
                                    }}
                                >
                                    <Caption color={pressable_text}>
                                        { item.label }
                                    </Caption>
                                </Button>
                            }
                        />
                    </ScrollView>
                </Modal.Body>
            </Modal.Content>
        </Modal>
    );
};
